import React, { useEffect, useState } from 'react';
import { api, configManager } from 'react-structure-admin';
import { Alert, Button, Empty, Popconfirm, Table, message } from 'antd';
import moment from 'moment';
import { oauthScopeLabels } from 'core/useOAuthRequest';

const OAUTH_TENANT = 'a';

const formatDate = (value) =>
  value ? moment(value).format('DD/MM/YYYY HH:mm') : '-';

const ConnectedAppsTab = () => {
  const [grants, setGrants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [revokingId, setRevokingId] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);

  const loadGrants = async () => {
    setLoading(true);
    setErrorMessage(null);

    const response = await api.fetch('oauth-grants', {}, null, OAUTH_TENANT);

    if (response.errors) {
      setErrorMessage(response.message);
      setGrants([]);
    } else {
      setGrants(response.data?.result ?? []);
    }

    setLoading(false);
  };

  const handleRevoke = async (id) => {
    setRevokingId(id);

    const response = await api.del('oauth-grants', id, OAUTH_TENANT);

    setRevokingId(null);

    if (response.errors) {
      message.error(response.message);
      return;
    }

    message.success('Aplicativo desconectado');
    loadGrants();
  };

  useEffect(() => {
    loadGrants();
  }, []);

  return (
    <div>
      {errorMessage ? (
        <Alert className="gx-mb-3" type="error" description={errorMessage} />
      ) : null}
      <Table
        {...configManager.getConfig().layout.list.table}
        loading={loading}
        rowKey={(record) => record.id}
        dataSource={grants}
        pagination={false}
        locale={{
          emptyText: (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="Nenhum aplicativo conectado."
            />
          )
        }}
        columns={[
          {
            title: 'Aplicativo',
            dataIndex: 'clientName'
          },
          {
            title: 'Contas',
            dataIndex: 'accounts',
            render: (accounts = []) => accounts.join(', ')
          },
          {
            title: 'Permissões',
            dataIndex: 'scopes',
            render: (scopes = []) =>
              scopes.map((c) => oauthScopeLabels[c] ?? c).join(', ')
          },
          {
            title: 'Conectado em',
            dataIndex: 'creationTime',
            render: formatDate
          },
          {
            title: 'Último uso',
            dataIndex: 'lastUsedAt',
            render: formatDate
          },
          {
            title: 'Ações',
            key: 'action',
            align: 'right',
            render: (_, { id }) => (
              <Popconfirm
                title="Desconectar este aplicativo? Ele perde o acesso à sua conta."
                onConfirm={() => handleRevoke(id)}
                okText="Sim"
                cancelText="Não"
              >
                <Button size="small" danger loading={revokingId === id}>
                  Desconectar
                </Button>
              </Popconfirm>
            )
          }
        ]}
      />
    </div>
  );
};

export default ConnectedAppsTab;
